import CountryFlag from './CountryFlag';

interface Props {
  from: string;
  to: string;
  /** Коды стран ISO-2. Пусто — флаг берётся по городу из справочника. */
  fromCountry?: string | null;
  toCountry?: string | null;
}

/**
 * Строка маршрута «откуда → куда» с флагами стран — единое место для
 * повторяющегося паттерна во всех списках (мои грузы, рейсы, парк,
 * админка), чтобы не размножать разметку флаг+стрелка по каждому экрану.
 */
export default function RouteLine({ from, to, fromCountry, toCountry }: Props) {
  return (
    <>
      <CountryFlag code={fromCountry} address={from} />
      {from} → <CountryFlag code={toCountry} address={to} />
      {to}
    </>
  );
}
